const translations = {
    filterButton: 'Filter',
    selected: 'Selected'
};

export default translations;
